var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.group)?_c('UIGroup',{class:_vm.classes,attrs:{"title":_vm.title,"subtitle":true,"collapsed":_vm.collapsed}},[_c('div',{class:_vm.layout},[_vm._t("default")],2)]):_c('div',{class:[_vm.classes, _vm.layout]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }